import React, { useState } from 'react';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogActions } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import SnackBarWiiba from 'components/Snackbar/SnackBarWiiba';
import ModalMovimientosLotes from 'views/Clientes/ModalMovimientosLotes';
import useMessage from '../../hooks/useMessage';

const useStyles = makeStyles(() => ({
  header: { background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 },
  logo: { height: 36, objectFit: 'contain' },
  headerTitle: { color: '#fff', fontSize: 16, fontWeight: 700, margin: 0 },
  headerSub: { color: '#cce5ff', fontSize: 11, margin: 0 },
  content: { padding: '16px 24px' },
  actions: { padding: '12px 24px', borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-end', gap: 8 }
}));

const ModalLotesCliente = ({
  modalLote, lotesCliente, setLotesCliente, setModalLote,
  getMovimientosxLote, movimientosLote, setMovimientosLote,
  getAmortizacionxLote, amortizacionxlote, setAmortizacionxLote
}) => {
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState();
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
  const [modalMov, setModalMov] = useState(false);
  const { opensnack, typesnackbar, message, handleMuestraSnack, handleClosesSnack } = useMessage();

  const columns = [
    { title: 'Desarrollo', field: 'NOMBRE_DESARROLLO' },
    { title: 'Manzana', field: 'CODIGO' },
    { title: 'Lote', field: 'LOTE', type: 'numeric' },
    { title: 'Superficie (m2)', field: 'SUPERFICIE', type: 'numeric' },
    { title: 'No. Contrato', field: 'ID_CONTRATO', type: 'numeric' },
    { title: 'ID_LOTE', field: 'ID_LOTE', hidden: true }
  ];

  const handleClose = () => { setModalLote(false); setLotesCliente([]); setSelectedRow(); };

  const handleConsultar = () => {
    if (!selectedRow) { handleMuestraSnack('Seleccione un lote', 'error'); return; }
    setContratoSeleccionado(selectedRow.ID_CONTRATO);
    setModalMov(true);
    getMovimientosxLote(selectedRow.ID_LOTE, null, null);
    getAmortizacionxLote(selectedRow.ID_CONTRATO);
  };

  return (
    <>
      <SnackBarWiiba opensnack={opensnack} tipoSnackBar={typesnackbar} mensaje={message} handleClosesSnack={handleClosesSnack} />
      <Dialog open={modalLote} onClose={handleClose} maxWidth="md" fullWidth>
        <div className={classes.header}>
          <div>
            <p className={classes.headerTitle}>Lotes del cliente</p>
            <p className={classes.headerSub}>Selecciona un lote para ver su detalle</p>
          </div>
        </div>
        <DialogContent className={classes.content}>
          <MaterialTable title="" columns={columns} data={lotesCliente}
            onRowClick={(_, row) => setSelectedRow(row)}
            options={{
              search: false, paging: true, pageSize: 5, toolbar: false,
              headerStyle: { fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: 11 },
              rowStyle: row => row && row.ID_LOTE === (selectedRow && selectedRow.ID_LOTE)
                ? { backgroundColor: '#e3f2fd', cursor: 'pointer' } : { cursor: 'pointer' }
            }}
            localization={{ body: { emptyDataSourceMessage: 'Sin lotes registrados' } }}
          />
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={handleClose} color="danger" size="sm">Cancelar</Button>
          <Button onClick={handleConsultar} color="info" size="sm" disabled={!selectedRow}>Ver detalle</Button>
        </DialogActions>
      </Dialog>
      <ModalMovimientosLotes
        modalMov={modalMov} movimientosLote={movimientosLote} setMovimientosLote={setMovimientosLote}
        setModalMov={setModalMov} getAmortizacionxLote={getAmortizacionxLote}
        amortizacionxlote={amortizacionxlote} setAmortizacionxLote={setAmortizacionxLote}
        idContrato={contratoSeleccionado}
      />
    </>
  );
};

export default ModalLotesCliente;